import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import { CustomButton } from '../shared/customButton';
import { CustomTextField } from '../shared/customTextField';
import { CustomTextFieldPass } from '../shared/textFieldPass';
import styles from './NewUserRegister.module.scss';
import { CustomAlertBox } from '../shared/customAlertBox';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { signUpNewUser, getNewUserInvitationDetails } from '../../services/util/auth';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CSSLoader from '../shared/cssLoader';

const NewUserRegister = (props) => {
    const [isLoading, setStatus] = useState(false);
    const [message, setMessage] = useState();
    const [show, setShow] = useState(false);
    let [companyDetails, setCompanyDetails] = useState('');
    const [isDataLoading, setDataLoading] = useState(false);
    const [companyName, setCompanyName] = useState('');
    let history = useNavigate();
    const { id } = useParams();

    //yup validations

    const schema = yup.object({
        firstName: yup.string().trim().max(20, 'maximum length is 20 characters').matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        lastName: yup.string().trim().max(20, 'maximum length is 20 characters').matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required("Required"),
        position: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required("Required"),
        password: yup.string().min(8, 'Minimum length is 8 characters').required('Password is Required')
    });

    const formFocus = () => {
        setShow(false)
    }

    //on submit function
    const onSubmit = async (values) => {
        const fname = values.firstName.trim();
        const lname = values.lastName.trim();
        setStatus(true)
        let response = await signUpNewUser(id, fname, lname, values.position, values.password);
        if (response.success === true) {
            setStatus(false)
            history('/signin')
        }
        else {
            setMessage(response.msg)
            setStatus(false)
            setShow(true)
        }
    }

    const getCompanyDetails = async (id) => {
        setDataLoading(true)
        let respond = await getNewUserInvitationDetails(id);
        if (respond.success === true) {
            setCompanyDetails(respond.data)
            setDataLoading(false)
        } else {
            setDataLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            getCompanyDetails(id);
        }
    }, []);

    useEffect(() => {
        let rootURL = window.location.pathname.split('/')[1];
        let userPage = window.location.pathname.split('/')[2];
        if (rootURL && userPage) {
            let pageHit = `/${rootURL}/${userPage}`;
            ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
            ReactGA.send({ hitType: "pageview", page: pageHit});
        }
    }, []);

    useEffect(() => {
        if (companyDetails && companyDetails.company_name) {
            setCompanyName(companyDetails.company_name)
        }
    }, [companyDetails]);
    

    return (
        <div>
            <Helmet>
                <title>Join Company Account | HireTrace</title>
            </Helmet>
            {isDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    <Row className={styles.mainRowSignup}>
                        <Col xs={12} md={6} className={styles.leftBar}>
                            <Container>
                                <Col className={styles.topicColumn}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 40C25.4247 40 40 25.4247 40 0C40 25.4247 54.5753 40 80 40C54.5753 40 40 54.5753 40 80C40 54.5753 25.4247 40 0 40Z" fill="white" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C7.62742 12 12 7.62742 12 0C12 7.62742 16.3726 12 24 12C16.3726 12 12 16.3726 12 24C12 16.3726 7.62742 12 0 12Z" fill="#FEC84B" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M64 24C69.0849 24 72 21.0849 72 16C72 21.0849 74.9151 24 80 24C74.9151 24 72 26.9151 72 32C72 26.9151 69.0849 24 64 24Z" fill="#FEC84B" />
                                    </svg>
                                    <p className={styles.topicDesc}>
                                        Start turning your <br />
                                        ideas into reality.
                                    </p>
                                    <p className={styles.secondDesc}>{companyName}, Invited you to join their hiring team.<br /> Join and collaborate with your hiring team. Get started in 2 minutes.</p>

                                </Col>
                                <Col className={styles.bottomColum}>
                                    <div className={styles.userImageDiv}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_1.png`} rounded fluid className={styles.companyLogo} />
                                    </div>
                                    <div className={styles.userImageDiv}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_2.png`} rounded fluid className={styles.companyLogo} />
                                    </div>
                                    <div className={styles.userImageDiv}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_3.png`} rounded fluid className={styles.companyLogo} />
                                    </div>
                                    <div className={styles.userImageDiv}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_4.png`} rounded fluid className={styles.companyLogo} />
                                    </div>
                                    <div className={styles.userImageDiv}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatars/user_avatar_cartoon_5.png`} rounded fluid className={styles.companyLogo} />
                                    </div>
                                    <div className={styles.userTexteDiv}>
                                        <p className={styles.bottomDesc}>Join 40,000+ users</p>
                                    </div>

                                    {/* <a href="https://www.youtube.com/watch?v=mNNY_2Ry_s8&ab_channel=HireTrace" target="_blank" rel="noreferrer">
                                <button className={styles.requestDemoBtn}>View Demo Video</button>
                            </a> */}
                                </Col>
                            </Container>
                        </Col>
                        <Col xs={12} md={6}>
                            <Container className={styles.mainContainer}>
                                <Row>
                                    <Col className={styles.leftColumnMain}>
                                        <div className={styles.companySecondLogoDiv}>
                                            <a href="/" target="_blank" rel="noreferrer">
                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                            </a>
                                        </div>
                                        <div className={styles.companyLogoTextDiv}>
                                            <p>Hiretrace</p>
                                        </div>
                                    </Col>
                                    <Col className={styles.rightColumnMain}>
                                        <p className={styles.rightColumnTopText}>Have an account?</p>
                                        <Link to="/signin" className={styles.rightColumnTopSecondText}>
                                            Log in
                                        </Link>
                                    </Col>
                                </Row>

                                <Container>
                                    <Row className={styles.createAccountRow}>
                                        <Col sm={10} xl={6} className={styles.createAccountDiv}>
                                            <p className={styles.createAccountTitle}>Welcome !</p>
                                            {/* <p className={styles.createAccountSubTitle}>{companyDetails.company_name}</p> */}
                                            <p className={styles.createAccountSubTitle}>{companyName}, Invited you to join their hiring team. Please enter below details to continue.</p>
                                        </Col>
                                    </Row>
                                    {
                                        show === true ?
                                            (
                                                <Row className={styles.formRow}>
                                                    <Col sm={10} xl={6} className={styles.alertColumn}>
                                                        <Col>
                                                            <CustomAlertBox alertBodyText={message} alertType='dangerAlert' />
                                                        </Col>
                                                    </Col>
                                                </Row>
                                            )
                                            : ''

                                    }
                                    <Row className={styles.formRow}>
                                        <Col sm={10} xl={6}>
                                            <Formik
                                                validationSchema={schema}
                                                onSubmit={(values) => onSubmit(values)}
                                                initialValues={{}}>

                                                {({
                                                    errors,
                                                    handleChange,
                                                    handleSubmit,
                                                    submitCount
                                                }) => (
                                                    <Form noValidate onSubmit={handleSubmit} onFocus={() => formFocus()}>
                                                        <Col className={styles.inputFieldsColumns}>
                                                            <CustomTextField
                                                                label="First Name*"
                                                                classLabel="defaultLabel"
                                                                controlId="newUserRegister_firstName_firstNameFieldId"
                                                                type="text"
                                                                name="firstName"
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.firstName}
                                                                validationMessageId="newUserRegister_firstName_firstNameValidationMsgId"
                                                                isInvalid={submitCount > 0 && !!errors.firstName}
                                                            />
                                                        </Col>
                                                        <Col className={styles.inputFieldsColumns}>
                                                            <CustomTextField
                                                                label="Last Name*"
                                                                classLabel="defaultLabel"
                                                                controlId="newUserRegister_lastName_lastNameFieldId"
                                                                type="text"
                                                                name="lastName"
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.lastName}
                                                                validationMessageId="newUserRegister_lastName_lastNameValidationMsgId"
                                                                isInvalid={submitCount > 0 && !!errors.lastName}
                                                            />
                                                        </Col>
                                                        <Col className={styles.inputFieldsColumns}>
                                                            <CustomTextField
                                                                label="Position*"
                                                                classLabel="defaultLabel"
                                                                controlId="newUserRegister_position_positionFieldId"
                                                                type="text"
                                                                name="position"
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.position}
                                                                validationMessageId="newUserRegister_position_positionValidationMsgId"
                                                                isInvalid={submitCount > 0 && !!errors.position}
                                                            />
                                                        </Col>
                                                        <Col className={styles.inputFieldsColumns}>
                                                            <CustomTextFieldPass
                                                                label="Password*"
                                                                classLabel="defaultLabel"
                                                                controlId="newUserRegister_password_passwordFieldId"
                                                                name="password"
                                                                placeholder="Set password for min 8 characters"
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.password}
                                                                validationMessageId="newUserRegister_password_passwordValidationMsgId"
                                                                isInvalid={
                                                                    submitCount > 0 && !!errors.password
                                                                }
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <p className={styles.paymentDesc}></p>
                                                        </Col>
                                                        <Col sm={12} className='mt-5 p-0'>

                                                            {<CustomButton
                                                                buttonType="submit"
                                                                id="newUserRegister_signUp_signUpSubmitBtnId"
                                                                label="Sign Up"
                                                                type="primaryBtn"
                                                                disabled={isLoading === true ? true : false}
                                                                backicon=
                                                                {isLoading === true ?
                                                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                                                                    : ''
                                                                }

                                                            />}


                                                        </Col>
                                                        <Col>
                                                            <p className={styles.signupBottomMessage}>By clicking the "Sign Up" button, you're agreeing to accept the HireTrace </p>
                                                            <p className={styles.termsPara}><a href="/privacy-policy" target="_blank" rel="noreferrer" className={styles.termsLink}>Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank" rel="noreferrer" className={styles.termsLink}>Terms of Use.</a></p>
                                                        </Col>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                </Container>
                                <Row className={styles.bottomRow}>
                                    <Col>
                                        <p>© Hiretrace 2024</p>
                                    </Col>
                                    <Col>
                                        <div className={styles.helpEmailDiv}>
                                            <svg className={styles.emailIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M1.33334 4.66669L6.77662 8.47698C7.2174 8.78553 7.43779 8.9398 7.67752 8.99956C7.88927 9.05234 8.11075 9.05234 8.3225 8.99956C8.56223 8.9398 8.78262 8.78553 9.2234 8.47698L14.6667 4.66669M4.53334 13.3334H11.4667C12.5868 13.3334 13.1468 13.3334 13.5747 13.1154C13.951 12.9236 14.2569 12.6177 14.4487 12.2413C14.6667 11.8135 14.6667 11.2535 14.6667 10.1334V5.86669C14.6667 4.74658 14.6667 4.18653 14.4487 3.75871C14.2569 3.38238 13.951 3.07642 13.5747 2.88467C13.1468 2.66669 12.5868 2.66669 11.4667 2.66669H4.53334C3.41324 2.66669 2.85319 2.66669 2.42536 2.88467C2.04904 3.07642 1.74308 3.38238 1.55133 3.75871C1.33334 4.18653 1.33334 4.74658 1.33334 5.86669V10.1334C1.33334 11.2535 1.33334 11.8135 1.55133 12.2413C1.74308 12.6177 2.04904 12.9236 2.42536 13.1154C2.85319 13.3334 3.41324 13.3334 4.53334 13.3334Z" stroke="#667085" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <p className={styles.helpText}>support@hiretrace.io</p>
                                        </div>

                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </div>)
            }
        </div>
    )
}

export default NewUserRegister;
